"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgTime(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M12 0a8 8 0 110 16 8 8 0 010-16zm0 2a6 6 0 100 12 6 6 0 000-12zm.25 2v4.535l3.009 1.93-.865 1.292-3.644-2.48V4z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Time')(SvgTime);
//# sourceMappingURL=Time.js.map